import { LineCapabilitiesIconProps } from './LineCapabilitiesIcon.decl';

import { SmsInboundFilled } from '@aircall/icons';
import { Icon, Tag, Tooltip } from '@aircall/tractor-v2';
import { ReactComponent as MmsIcon } from '@assets/icons/mms_icon.svg';
import { ReactComponent as WhatsappIcon } from '@assets/icons/whatsapp_icon.svg';
import { LINE_CAPABILITY } from '@constants/numbers.constants';
import { useFeaturesFlags } from '@hooks/useFeatures/useFeaturesFlags';

const CAPABILITY_ICONS = {
  [LINE_CAPABILITY.SMS]: {
    icon: SmsInboundFilled,
    testId: 'sms-tag',
    iconColor: 'primary-500',
    size: 22,
    tooltipKey: 'SMS',
  },
  [LINE_CAPABILITY.MMS]: {
    icon: MmsIcon,
    testId: 'mms-tag',
    size: 20,
    iconColor: 'primary-500',
    tooltipKey: 'MMS',
  },
  [LINE_CAPABILITY.WA_MSG]: {
    icon: WhatsappIcon,
    testId: 'whatsapp-tag',
    iconColor: 'primary-500',
    size: 20,
    tooltipKey: 'WhatsApp',
  },
};

export function LineCapabilitiesIcon({
  capabilities,
  isNumberDetail,
}: Readonly<LineCapabilitiesIconProps>) {
  const { enableWhatsappAdmin } = useFeaturesFlags();

  const activeCapabilities = Object.entries(CAPABILITY_ICONS).filter(([capability]) => {
    if (!enableWhatsappAdmin && capability === LINE_CAPABILITY.WA_MSG) {
      return false;
    }
    return capabilities?.includes(capability);
  });

  if (activeCapabilities.length === 0) {
    return null;
  }

  const capabilitiesMap = capabilities?.reduce((acc, capability) => {
    if (!capability) {
      return acc;
    }
    acc[capability] = true;
    return acc;
  }, {} as Record<string, boolean>);

  const icons = [];
  /* istanbul ignore next */
  if (capabilitiesMap?.[LINE_CAPABILITY.SMS] && capabilitiesMap?.[LINE_CAPABILITY.MMS]) {
    icons.push({
      ...CAPABILITY_ICONS[LINE_CAPABILITY.MMS],
      tooltipKey: 'SMS & MMS',
    });
  } else if (capabilitiesMap?.[LINE_CAPABILITY.MMS]) {
    icons.push({
      ...CAPABILITY_ICONS[LINE_CAPABILITY.MMS],
      tooltipKey: 'MMS',
    });
  } else if (capabilitiesMap?.[LINE_CAPABILITY.SMS]) {
    icons.push({
      ...CAPABILITY_ICONS[LINE_CAPABILITY.SMS],
      tooltipKey: 'SMS',
    });
  }

  if (enableWhatsappAdmin && capabilitiesMap?.[LINE_CAPABILITY.WA_MSG] && !isNumberDetail) {
    icons.push(CAPABILITY_ICONS[LINE_CAPABILITY.WA_MSG]);
  }

  return (
    <>
      {icons.map(({ icon, testId, iconColor, size, tooltipKey }) => (
        <Tooltip key={testId} content={tooltipKey}>
          <Tag data-test={testId} style={{ backgroundColor: 'transparent' }}>
            <Icon component={icon} size={size} color={iconColor} />
          </Tag>
        </Tooltip>
      ))}
    </>
  );
}
